function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M8.90482 24.4483C8.90482 23.8173 8.40972 23.4409 7.53617 23.4409C7.17946 23.4409 6.93788 23.4721 6.81152 23.5018V25.5266C6.96114 25.5564 7.14507 25.5663 7.39859 25.5663C8.3297 25.5663 8.90482 25.1503 8.90482 24.4483Z",
  fill: "#1C355E"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.3126 23.4619C13.9214 23.4619 13.6686 23.4918 13.519 23.5228V28.007C13.6687 28.0381 13.9102 28.0381 14.1286 28.0381C15.7156 28.048 16.7506 27.2754 16.7506 25.6382C16.7619 24.2146 15.8187 23.4619 14.3126 23.4619Z",
  fill: "#1C355E"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M24.3597 0H7.10367C4.58273 0 2.53095 1.81599 2.53095 4.04441V19H2.08433C1.06686 19 0.241699 19.7291 0.241699 20.6298V30.5136C0.241699 31.4142 1.06678 32.1432 2.08433 32.1432H2.53095V33.9556C2.53095 36.1865 4.58273 38 7.10367 38H30.6488C33.1681 38 35.2201 36.1864 35.2201 33.9556V9.57206L24.3597 0ZM5.07569 22.4135C5.6157 22.3328 6.37474 22.2719 7.44416 22.2719C8.52489 22.2719 9.29517 22.4544 9.81272 22.8209C10.3071 23.1662 10.6407 23.7363 10.6407 24.4072C10.6407 25.0779 10.3879 25.6481 9.92794 26.0344C9.32965 26.5325 8.44487 26.7561 7.40985 26.7561C7.1795 26.7561 6.97303 26.746 6.81156 26.7262V29.1771H5.07569V22.4135ZM30.6488 35.5231H7.10367C6.12755 35.5231 5.33268 34.8201 5.33268 33.9556V32.1432H27.2815C28.2992 32.1432 29.1243 31.4142 29.1243 30.5136V20.6298C29.1243 19.7291 28.2992 19 27.2815 19H5.33268V4.04441C5.33268 3.18233 6.12764 2.4793 7.10367 2.4793L23.312 2.46432V7.76332C23.312 9.3111 24.7319 10.5681 26.4832 10.5681L32.3522 10.5532L32.4182 33.9555C32.4182 34.8201 31.6248 35.5231 30.6488 35.5231ZM11.7601 29.146V22.4135C12.4039 22.3228 13.243 22.2719 14.1286 22.2719C15.6004 22.2719 16.5547 22.5054 17.3026 23.0035C18.1073 23.5326 18.6128 24.3761 18.6128 25.5871C18.6128 26.8988 18.0728 27.8044 17.3249 28.3633C16.5089 28.9633 15.2668 29.2478 13.7494 29.2478C12.8406 29.2478 12.1968 29.1969 11.7601 29.146ZM24.3092 25.1599V26.4207H21.5263V29.1771H19.7673V22.3228H24.5044V23.5935H21.5263V25.1599H24.3092Z",
  fill: "#1C355E"
});

var SvgPdf = function SvgPdf(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 36,
    height: 38,
    viewBox: "0 0 36 38",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPdf, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdf.b160d618.svg";
export { ForwardRef as ReactComponent };